import React from "react";
import styled from "styled-components";

const Card = styled.div`
  display: flex;
  align-items: center;
  padding: 30px 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  flex: 1 1 calc(33.333% - 20px);
  max-width: 495px;
  transition: transform 0.3s, box-shadow 0.3s;
  font-family: "Poppins", system-ui;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(255, 255, 255, 0.2);
  }

  @media (max-width: 768px) {
    flex: 1 1 calc(50% - 20px);
    max-width: calc(50% - 20px);
  }

  @media (max-width: 480px) {
    flex: 1 1 100%;
    max-width: 100%;
  }
`;

const Icon = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  color: ${(props) => props.iconColor};
  font-size: 2.5em;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h3`
  font-size: 1.1em;
  margin: 0 0 10px 0;
  color: #095171;
  line-height: 1.71;
  font-weight: 500;

  @media (max-width: 480px) {
    font-size: 1.2em;
  }
`;

const Description = styled.p`
  margin: 0;
  color: #777777;
  text-align: justify;
  font-size: 0.9em;
  line-height: 1.71;
    letter-spacing: 0.5px;
  hyphens: auto;

  @media (max-width: 480px) {
    font-size: 0.91em;
  }
`;

const FeatureCard = ({ icon, title, description, iconColor }) => (
  <Card>
    <Icon iconColor={iconColor}>{icon}</Icon>
    <Content>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Content>
  </Card>
);

export default FeatureCard;
